<div>
    <p-breadcrumb class="max-w-full" [model]="breadcrumbList"></p-breadcrumb>
</div>
<div class="mt-1" *ngIf="displayMenu">
    <div class="flex flex-row align-items-center overflow-x-auto column-gap-4">
        <div *ngFor="let menu of menuList" class="column-gap-1 menu-item-list flex align-items-baseline cursor-pointer" [class.active]="menu.routerLink === navService.activeSubMenu" (click)="navigateTo(menu)">
            <div [inlineSVG]="menu.icon"></div>
            <div class="font-semibold text-sm">{{menu.label}}</div>
        </div>
    </div>
</div>